import React from 'react';

const AppVersion = () => {
  return (
    <div style={{
      position: 'fixed',
      bottom: '10px',
      right: '10px',
      fontSize: '11px',
      color: '#95a5a6',
      background: 'rgba(255,255,255,0.9)',
      padding: '4px 8px',
      borderRadius: '4px',
      zIndex: 1000,
      fontFamily: 'monospace'
    }}>
      MealPoint v1.0.0
    </div>
  );
};

export default AppVersion;
